import {SALO_STRING_MAP} from '../constants';
import type {SearchCriteria, SmallSALO} from '../types';

/**
 * Helper for converting search criteria to a condensed object
 * Used for the advanced search base64 encoded url param
 * @param criteria
 * @returns SmallSALO
 */
export const searchCriteriaToSmallSALO = (
	criteria: SearchCriteria,
	skipLastN?: number,
) => {
	const totalRules = criteria.elementTypes.length;
	return Object.entries(SALO_STRING_MAP).reduce<SmallSALO>(
		(accum, [small, key]) => {
			return {
				...accum,
				[small]:
					key === 'matchCriteria' || key === 'sortField' || key === 'sortOrder'
						? criteria[key]
						: criteria[key].slice(
								0,
								skipLastN != null ? totalRules - skipLastN : undefined,
							),
			};
		},
		{
			a: 'file',
			b: 0,
			c: 0,
			d: [],
			e: [],
			f: [],
			g: [],
			h: [],
			i: [],
		},
	);
};

export default searchCriteriaToSmallSALO;
